import ListView from "./ListView/ListView";

const DataPks = {
  ListView,
};

export default DataPks;
